import { type AxiosError } from 'axios'
import domPurify from 'dompurify'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  ContactControllerApiFactory,
  type ContactRequestV1,
} from '@redteclab/api/clients/bully'

import { useBullyApi } from '../../../base-api-communication'
import { useGlobalConfigContext } from '../../../global-config'

const getContactFormApiSwrContactPostMutationKey = (): string => {
  return 'ContactFormApiSwrContactPostMutation'
}

export const useContactFormApiPostMutation = (): SWRMutationResponse<
  void,
  AxiosError,
  string,
  ContactRequestV1
> => {
  const globalConfig = useGlobalConfigContext()
  const client = useBullyApi(ContactControllerApiFactory)

  return useSWRMutation(
    getContactFormApiSwrContactPostMutationKey(),
    async (_swrKey: string, data: { arg: ContactRequestV1 }) => {
      const response = await client.contactV1TenantLanguageContactPost({
        ContactRequestV1: {
          ...data.arg,
          email: domPurify.sanitize(data.arg.email),
          firstName: domPurify.sanitize(data.arg.firstName),
          lastName: domPurify.sanitize(data.arg.lastName),
          message: domPurify.sanitize(data.arg.message),
          orderId: data.arg.orderId && domPurify.sanitize(data.arg.orderId),
        },
        language: globalConfig.language,
        tenant: globalConfig.tenantAndEnv,
      })

      return response.data
    },
  )
}
